import React, { useState, useEffect } from 'react';
import Filters from '../../../components/Headers/Filters'
import api from "../../../services/api";
import {
    Row,
    Col,
    Input,
    FormGroup,
    ButtonGroup,
    Button
} from "reactstrap";
import classnames from "classnames";
import { SITUACOES_SCRIPT } from './constants'

export default ({ title, notify, load, presets, actions, ...props }) => {

    const [titulo, setTitulo] = useState("")
    const [tags, setTags] = useState("")
    const [status, setStatus] = useState("A")
    const [situacao, setSituacao] = useState("")
    const [perfilNegocioId, setPerfilNegocioId] = useState("")
    const [perfisNegocio, setPerfisNegocio] = useState([])
    const [runLoad, setRunLoad] = useState(props.search ? props.search : true)

    useEffect(() => {
        loadPerfisNegocio()
    }, [])

    useEffect(() => {
        if (runLoad) {
            search()
            setRunLoad(false)
        }
    }, [runLoad])

    useEffect(() => {
        if (!runLoad) {
            search()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, situacao, perfilNegocioId])

    async function loadPerfisNegocio() {
        try {
            const response = await api.get('/common/perfis_negocio')
            setPerfisNegocio(response.data || [])
        } catch (err) {
            console.log(err)
        }
    }

    function search() {
        load({
            titulo,
            tags,
            status,
            situacao,
            perfil_negocio_id: perfilNegocioId
        })
    }

    function hanldeClearFilter() {
        setTitulo('')
        setTags('')
        setStatus('A')
        setSituacao('')
        setPerfilNegocioId('')
    }

    return (
        <>
            <Filters
                onSearch={search}
                title={<h1>Scripts de Venda</h1>}
                onFiltersClead={hanldeClearFilter}
                presets={() => (
                    <>
                        <ButtonGroup className="btn-group-toggle mr-3" size="sm" data-toggle="buttons">
                            {[{ id: "", text: "Todos" }, { id: "A", text: "Ativos" }, { id: "I", text: "Inativos" }].map((item) => (
                                <Button
                                    key={item.id}
                                    className={classnames({ active: status === item.id })}
                                    color="secondary"
                                    onClick={() => setStatus(item.id)}
                                >
                                    {item.text}
                                </Button>
                            ))}
                        </ButtonGroup>
                        {presets && presets()}
                    </>
                )}
                actions={actions}
            >
                <Row className="py-4">
                    <Col lg={6} md={12}>
                        <FormGroup>
                            <label className="form-control-label">
                                Título
                            </label>
                            <Input
                                className="form-control-alternative"
                                placeholder="Título..."
                                type="text"
                                value={titulo}
                                onChange={(e) => setTitulo(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg={6} md={12}>
                        <FormGroup>
                            <label className="form-control-label">
                                Tags
                            </label>
                            <Input
                                className="form-control-alternative"
                                placeholder="Tags..."
                                type="text"
                                value={tags}
                                onChange={(e) => setTags(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg={6} md={12}>
                        <FormGroup>
                            <label className="form-control-label">
                                Situação
                            </label>
                            <Input
                                className="form-control-alternative"
                                type="select"
                                value={situacao}
                                onChange={(e) => setSituacao(e.target.value)}
                            >
                                <option value="">Todas</option>
                                {SITUACOES_SCRIPT.map((s) => (
                                    <option key={s.value} value={s.value}>{s.label}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col lg={6} md={12}>
                        <FormGroup>
                            <label className="form-control-label">
                                Perfil de Negócio
                            </label>
                            <Input
                                className="form-control-alternative"
                                type="select"
                                value={perfilNegocioId}
                                onChange={(e) => setPerfilNegocioId(e.target.value)}
                            >
                                <option value="">Todos</option>
                                {perfisNegocio.map((p) => (
                                    <option key={p.id} value={p.id}>{p.nome}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
            </Filters>
        </>
    );
}
